import { Button } from '../../components/Buttons'
import img from './assets/NoFound404.svg'

import { s } from './styles'

type Props = {
  title?: string
  subTitle?: string
}

export const NoFound404 = (props: Props) => {
  const { title, subTitle } = props

  return (
    <s.Box>
      <s.Img dangerouslySetInnerHTML={{ __html: img }} />
      <s.Title>{title || 'Page Not Found'}</s.Title>
      <s.SubTitle>{subTitle || 'The page may have been moved or deleted.'}</s.SubTitle>
      <a href="/">
        <Button face="primary">Go home</Button>
      </a>
    </s.Box>
  )
}
